@if (!authenticated) {
  <div class="login-spinner">
    <mat-spinner></mat-spinner>
  </div>
}

@if (authenticated) {
  <app-navbar></app-navbar>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
}